import { render, staticRenderFns } from "./MobileOtp.vue?vue&type=template&id=1f5c6868&scoped=true&"
import script from "./MobileOtp.vue?vue&type=script&lang=js&"
export * from "./MobileOtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5c6868",
  null
  
)

export default component.exports